$(function () {

    let dataCountry = $('#dqeForm [data-dqe="country"]');
    let dataCountrySelected = $('#dqeForm [data-dqe="country"] option:selected');
    let dataSingle = $('[data-dqe="single"]');
    let dataZip = $('[data-dqe="zip"]');
    let dataCity = $('[data-dqe="city"]');
    let dataCompl = $('[data-dqe="compl"]');
    let dataLocal = $('[data-dqe="local"]');

    window.dqeServer = '/dqe';
    window.dqeLicense = '';
    window.dqeLast_log_line = '';
    window.dqeMap = dataCountry.data('dqe-map');

    $('#dqeForm [data-dqe="country"] option').each(function () {
        if ($(this).val() in window.dqeMap) {
            $(this).data('dqe-code', window.dqeMap[$(this).val()]);
        } else {
            $(this).data('dqe-code', 'ZZZ');// TODO beurk
        }
    });

    dataCountry.on('change', function () {
        window.dqeObject.country = dataCountrySelected.data('dqe-code');
        dataSingle.val('');
        dataZip.val('');
        dataCity.val('');
        dataCompl.val('');
        dataLocal.val('');
    });

    window.dqeObject = $('#dqeForm').dqe({
        server: window.dqeServer,
        license: window.dqeLicense,
        country: dataCountrySelected ? dataCountrySelected.data('dqe-code') : 'ZZZ',// TODO beurk
        single: '[data-dqe="single"]',
        zip: '[data-dqe="zip"]',
        city: '[data-dqe="city"]',
        street: '[data-dqe="single"]',
        compl: '[data-dqe="compl"]',
        local: '[data-dqe="local"]'
    });

    let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    let autocomplete = isChrome ? 'nope' : 'off';

    dataSingle.on('input', function () {
        $(this).attr('autocomplete', autocomplete);
    });
    dataSingle.on('change', function () {
        $(this).attr('autocomplete', autocomplete);
    });
    dataSingle.on('focus', function () {
        $(this).attr('autocomplete', autocomplete);
    });

    dataZip.attr('autocomplete', autocomplete);
    dataCity.attr('autocomplete', autocomplete);
    dataCompl.attr('autocomplete', autocomplete);
    dataLocal.attr('autocomplete', autocomplete);
    dataSingle.attr('autocomplete', autocomplete);
});
